import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import MaterialBrandAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-brand/material-brand.entity';
import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CompanyService } from '../../configuration/company/company.service.service';
import { ICreateMaterialBrand } from './interfaces/create-material-brand.interface';
import { IUpdateMaterialBrand } from './interfaces/update-material-brand.interface';
import { MaterialBrandService } from './material-brand.service';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from 'app/layout/export-overlay/tasks/core/export-task.interfaces';
import { MaterialBrandExport } from './exports/material-brand.export';
import { MATERIAL_BRAND_TITLE } from './exports/material-brand.constants';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: 'app-material-brand',
  templateUrl: './material-brand.component.html',
  styleUrl: './material-brand.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent, 
    NgSelectModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    MaterialBrandExport
  ],
})

export class MaterialBrandComponent implements AfterViewInit, OnDestroy {
  displayedColumns: string[] = ["code", "company", "statusId", "actions"];
  currentCreateMaterialBrand: ICreateMaterialBrand = this.initializeCreateMaterialBrand();
  currentUpdateMaterialBrand: MaterialBrandAttributes | undefined | any;

  companyList: CompanyAttributes[] = [];
  selectedCompanyIds: string[] = [];

  dataSource: MaterialBrandAttributes[] = [];
  searchQuery = '';
  totalItems = 0;
  pageSize = 50;
  pageIndex:number = 1;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: [] = [];
  form: FormGroup;

  loadFiltersData = false;
  private companiesLoaded = false;

  constructor(
    private readonly companyService: CompanyService,
    private readonly materialBrandService: MaterialBrandService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private materialBrandExport: MaterialBrandExport,
    private fb: FormBuilder
    ) { 
      this.form = this.fb.group({
        companyId: [],
      }); 

  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private initializeCreateMaterialBrand(): ICreateMaterialBrand {
    return { code: "", name: "", companyId: "" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      this.companiesLoaded = true;
    });
  }

  findAllWithCount(): void {
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";
    const companyCodes = this.form.get("companyId")?.value;


    this.materialBrandService
      .findAllWithCount(
        { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection },
        companyCodes,
        this.selectedStatuses
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof MaterialBrandAttributes {
    const validSortFields: (keyof MaterialBrandAttributes)[] = ["code", "name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof MaterialBrandAttributes) ? (this.sort.active as keyof MaterialBrandAttributes) : "code";
  }

  private getSelectedCompanyCodes(selectedIds: string[]): number[] {
    return selectedIds.map((id) => this.companyList.find((company) => company._id.toString() === id)?.id );
  }

  onCompanySelectionChange(selectedIds: string[]): void {
    this.selectedCompanyIds = selectedIds;
  }
  
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount(); 
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: MaterialBrandAttributes): string {
    return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchCompanies();
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
  }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.findAllWithCount();
  }

  openCreateModal(): void {
    this.ensureCompaniesLoaded();
    this.currentCreateMaterialBrand = this.initializeCreateMaterialBrand();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createMaterialBrand());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(materialBrand: MaterialBrandAttributes): void {
    this.ensureCompaniesLoaded();
    this.currentUpdateMaterialBrand = { ...materialBrand };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
      // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateMaterialBrand(materialBrand._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createMaterialBrand(): void {
    this.materialBrandService.create(this.currentCreateMaterialBrand).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateMaterialBrand(id: string): void {
    if (this.currentUpdateMaterialBrand) {
      const updatedMaterialBrand: IUpdateMaterialBrand = { 
        companyId: this.currentUpdateMaterialBrand.company._id.toString(),
         ...this.currentUpdateMaterialBrand };

      this.materialBrandService.update(id, updatedMaterialBrand).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, materialBrand: MaterialBrandAttributes): void {
    const originalStatusId = materialBrand.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedMaterialBrand = { ...materialBrand, statusId: updatedStatusId };

    this.materialBrandService.update(materialBrand._id.toString(), updatedMaterialBrand as any).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        materialBrand.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(materialBrand: MaterialBrandAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: materialBrand, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(materialBrand._id.toString()));
  }

  delete(id: string): void {
    this.materialBrandService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  //exportar materialBrandExport
  onExportButtonPressed() {
    if (!this.materialBrandExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: MATERIAL_BRAND_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.materialBrandExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
